export default __webpack_public_path__ + "static/media/bg4.946ceaf2.jpg";